export const SITE = {
  name: "MD Custom Construction",
  phone: "(240) 587-2207",
  phoneHref: "tel:2405872207",
  email: "admin@mdcustomconstruction.com",
  address: {
    street: "24385 Mervell Dean Rd",
    city: "Hollywood",
    region: "MD",
    postal: "20636",
  },
  hours: "Mon–Fri: 8:00 AM – 4:30 PM • Sat–Sun: Closed",
  licenses: ["MHIC #110740", "MHBR #8487"],
 tagline: "Built Right. Done When We Said. Priced Like We Told You.",
  subTagline:
    "A family-run remodeling crew out of Hollywood, MD. Kitchens, baths, basements, decks and roofs across St. Mary's, Calvert and Charles counties since 2009.",
};

export const SERVICES = [
  { slug: "kitchen-remodeling", name: "Kitchen Remodeling", card: "Kitchen Remodeling Service" },
  { slug: "bathroom-remodeling", name: "Bathroom Remodeling", card: "Bathroom Remodeling Service" },
  { slug: "basement-finishing", name: "Basement Finishing", card: "Basement Finishing Service" },
  { slug: "deck-construction", name: "Deck Construction", card: "Deck Construction Service" },
  { slug: "screen-room", name: "Screen Room", card: "Screen Room Construction Service" },
  { slug: "garage-construction-service", name: "Garage Construction", card: "Garage Construction Service" },
  { slug: "home-improvement-services", name: "Home Improvement", card: "Home Improvement Service" },
  { slug: "roofing-services", name: "Roofing", card: "Roofing Service" },
] as const;

export type ServiceSlug = (typeof SERVICES)[number]["slug"];

export const servicePath = (slug: string) => `/home-remodeling-services/${slug}/`;